import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";

const useStyles = makeStyles(theme => ({
  table: {
    fontSize: 13
  },
  tableCell: {
    padding: "4px 8px",
    fontSize: 12,

    fontWeight: "normal !important"
  },
  tableBodyCell: {
    fontSize: 10
  },
  noBorderBottom: {
    borderBottom: "none"
  }
}));

function ExampleTable({ tableData }) {
  const classes = useStyles();

  return (
    <Table className={classes.table}>
      <TableHead>
        <TableRow>
          {Object.keys(tableData[0]).map((field, j) => (
            <TableCell key={j} className={classes.tableCell}>
              {field}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {tableData.map((obj, j) => (
          <TableRow key={j}>
            {Object.keys(obj).map((data, k) => (
              <TableCell
                key={k}
                className={`${classes.tableCell} ${classes.tableBodyCell} ${
                  j === tableData.length - 1 ? classes.noBorderBottom : null
                }`}
              >
                {obj[data] ? obj[data] : "-"}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ExampleTable;
